export default __webpack_public_path__ + "static/media/icon-pinterest.7d446845.svg";